const coImagesGlobalLoader = document.querySelectorAll('img.co-image-global-loader');
coImagesGlobalLoader.forEach((img) => {
    // Function to handle when an image is loaded
    const coHandleImageLoad = () => {
        // console.log("image loaded");
        img.classList.add("co-image-loaded");
    };
    // Check if the image is already loaded
    if (img.complete) {
        // coHandleImageLoad();
        img.classList.add("co-image-completed");
        // console.log("image complete");
    } else {
        img.addEventListener('load', coHandleImageLoad);
    }
});